/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'

import './styles.scss'
// import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Dashboard } from 'components/Dashboard'

const ARTICLE_ID = '16280941'
const ADDITIONAL_SHARES = 219

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical fitted segment'>
        <div className='ui container'>
          <h1 className='ui header' style={{ marginBottom: 0 }}>
            So lange müssen Sie für den Lohn der anderen arbeiten
          </h1>
          <h2 className='ui header' style={{ marginTop: 0 }}>
            <div className='small sub header'>
              Vergleichen Sie Ihr Gehalt mit jenem von Kita-Praktikantinnen,
              Lokführern, Bankenchefs und Roger Federer.
            </div>
          </h2>
          <p className='ta author'>
            <strong>Patrick Vögeli, Dinja Plattner und Marc Brupbacher</strong>
          </p>
        </div>
      </header>

      {/* TODO And probably remove the following segment and replace it with
       your own content */}
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <p>
            4000 Franken – so viel verdient eine Coiffeuse im Monat inkl. Anteil
            13.&nbsp;Monatslohn. Roger Federer scheffelt in der gleichen Zeit
            7'644'012 Franken. Eine Coiffeuse müsste für diese Summe 168 Jahre,
            1 Monat und 21 Tage arbeiten. Auch der Schweizer
            Durchschnittsverdiener, welcher im Median pro Monat 6502 Franken
            Lohn erhält, müsste für ein Monatssalär des Tenniskönigs ziemlich
            lange schuften. Erst nach 103 Jahren, 5 Monaten und 5 Tagen hätte er
            diesen Betrag erreicht. Der Durchschnittsschweizer müsste hingegen
            für das Gehalt eines Coiffeurs nur 14 Tage pro Monat arbeiten.
          </p>
          <p>
            Wie sieht es mit Ihrem Lohn aus im Vergleich zu anderen Berufen?
          </p>
        </div>
        <div className='ui text container dashboardWrapper'>
          <Dashboard articleId={ARTICLE_ID} />
        </div>
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        additionalShares={ADDITIONAL_SHARES}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie unterhaltsam war er?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          [
            'Konzept, Programmierung und Umsetzung',
            'Patrick Vögeli, Dinja Plattner und Marc Brupbacher'
          ],
          [
            'Inspiration/Adaption',
            `<a href='https://interaktiv.waz.de/das-gehalt-der-anderen-gehaltsvergleich/'>«Wie lange arbeiten Sie für das Gehalt der anderen?»</a>, Funke Interaktiv`
          ]
        ]}
        starColor='yellow'
      >
        <div className='ui vertical grey segment' id='methodik'>
          <div
            className='ui text container methodik'
            style={{ position: 'relative' }}
          >
            <div className='innerWrapperMethodik'>
              <h2 className='methodik' style={{ paddingBottom: '1rem' }}>
                Methodik
              </h2>
            </div>

            <p>
              Für den Vergleich wurden Monatswerte auf Arbeitstage umgerechnet,
              wobei ein Monat 22 Arbeitstagen entspricht und 250 Tage einem
              Arbeitsjahr. Monatslöhne sind bei unserer Berechnung Jahreslöhne
              geteilt durch 12. Den Bonus rechnen wir nur dazu, wenn er einen
              substanziellen Anteil des Gehalts ausmacht, wie beispielsweise bei
              Bankenchefs. Der Medianlohn bezieht sich auf das Jahr 2016, das
              aktuellste vom{' '}
              <a
                href='https://www.bfs.admin.ch/bfs/de/home/statistiken/arbeit-erwerb/loehne-erwerbseinkommen-arbeitskosten.html'
                style={{ whiteSpace: 'nowrap' }}
              >
                <i className='icon small external alternate' />
                Bund
              </a>{' '}
              ausgewertete Jahr.
            </p>
          </div>
        </div>
      </Footer>
    </div>
  )
}
